export const baseURL = "https://www.testnearz.co.in";
export const SEND_OTP = `${baseURL}/sign_up`;
export const VALIDATE_OTP = `${baseURL}/verify`;
export const GET_CATEGORIES = `${baseURL}/categories/nearby?`;
export const GET_SALON_LIST = `${baseURL}/salons/nearby?`;
export const GET_SALON_DETAILS = `${baseURL}/salons/`;
export const GET_SALON_MY_BOOKINGS = `${baseURL}/users/`;
export const BOOK_CANCEL_APPOINTMENT = `${baseURL}/appointments`;
export const GET_AVAILABLE_SLOTS = `${baseURL}/salons/`;
export const ADD_UPDATE_SALON = `${baseURL}/salons`;
export const GET_SERVICES = `${baseURL}/categories`;
export const ADD_EDIT_SERVICE = `${baseURL}/salon_services`;
export const DELETE_SERVICE = `${baseURL}/salon_services`;
export const SALON_ALL_APPOINTMENTS = `${baseURL}/salons`;
export const CONFIRM_DECLINE_APPOINTMENTS = `${baseURL}/appointments`;
export const ACTIVATE_DEACTIVATE_SALON = `${baseURL}/salons/`;
export const SUBMIT_FEEDBACK = `${baseURL}/feedbacks`;
export const SEARCH_SALON = `${baseURL}/salons?search_string=`;
export const SEARCH_SERVICE = `${baseURL}/services?search_string=`;
export const EXPENSES = `${baseURL}/expenses`;
export const VIEW_EXPENSES = `${baseURL}/salons/`;
export const UPDATE_UID = `${baseURL}/users/`;
export const UNRATED_APPOINTMENTS = `${baseURL}/users/`;
export const SUBMIT_RATING = `${baseURL}/salons/`;
export const TOP_SALONS = `${baseURL}/salons/top_salons?`;
export const ADD_USER_ADDRESS = `${baseURL}/users`;
export const DELETE_USER_ADDRESS = `${baseURL}/addresses`;
export const SET_PROFILE_IMAGE = `${baseURL}/salons`;
export const GET_SALON_USERS = `${baseURL}/salons`;
